import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Form, Input, Button, Spin, message } from 'antd';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AuthWrapper } from './style';
import Heading from '../../../../components/heading/heading';
import firebase, { database } from '../../../../firebase';

const SignIn = (props) => {
  
  const [isLoading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const isTrialExpired = await database.collection(`users`).where('email', '==', String(email.trim())).get();
      let userData = isTrialExpired.docs.length > 0 ? isTrialExpired.docs[0].data() : null;    
      if(userData !== null){
        let empresa_ref = await database.collection(`info_empresas`).doc(userData.empresa).get()      
        let empresaData = empresa_ref.exists ? empresa_ref.data() : null;            
        if(empresaData.pagamento_atrasado){   
          setLoading(false)
          return message.warning('Conta Bloqueada por Falta de Pagamentos, por favor entre em contato conosco!');
        }        
        if(empresaData.trial){        
          console.log('empresa',empresaData)        
          let validade = empresaData.validadeTrail;        
          let today = new Date()
          let diaFinalTrial = new Date(validade.seconds*1000)
          if (today > diaFinalTrial) {          
            console.log('Conta expirada')
            setLoading(false)
            return message.warning('Conta Trial Expirou, por favor entre em contato conosco!');
          }        
        }
      }
      const user = await firebase.auth().signInWithEmailAndPassword(email.trim(), senha);
      console.log('entered', user)      
    } catch (error) {
      console.log(error.code)
      switch (error.code) {
        case 'auth/too-many-requests':
          message.warning('Múltiplas tentavias de login foram requisitadas para o seu usuario. Troque de senha ou espere alguns minutos e tente novamente!')
          break;
        case 'auth/user-not-found':
          message.warning('Nenhum usuário foi encontrado com esse email!')
          break;
        case 'auth/wrong-password':
          message.warning('A senha inserida não corresponde com esse email!')
          break;
        default:
          alert(error.message)
          break;
      }
    }
    setLoading(false)
  }

  const [form] = Form.useForm();
  return (
    <AuthWrapper>
      {
        props.waitingForAuthCheck ? <div className="spin" style={{height: '100%'}}>
          <Spin size="large"/>
        </div>
        : <>
          <p className="auth-notice">
            Não tem uma conta? <a target="_blank" href="https://smtximob.com">Entre em contato com a gente!</a>
          </p>
          <div className="auth-contents">
            <Form name="login" onFinish={handleSubmit} layout="vertical">
              <Heading as="h3">
                Faça login na <span className="color-primary">Dashboard!</span>
              </Heading>
              <Form.Item
                name="username"
                rules={[{ message: 'Por favor insira seu email!', required: true }]}
                label="Seu email"
              >
                <Input placeholder="Insira seu email" value={email} onChange={e => setEmail(e.currentTarget.value)}/>
              </Form.Item>
              <Form.Item name="password" label="Senha" rules={[{ message: 'Por favor insira sua senha!', required: true }]}>
                <Input.Password placeholder="Insira sua senha" value={senha} onChange={e => setSenha(e.currentTarget.value)}/>
              </Form.Item>
              <Form.Item style={{marginBottom: 16}}>
                <Button onClick={form.submit} disabled={isLoading} className="btn-signin" htmlType="submit" type="primary" size="large">
                  {isLoading ? 'Carregando...' : 'Entrar'}
                </Button>
              </Form.Item>
              <div className="auth-form-action">
                <NavLink className="forgot-pass-link" to={`/password`}>
                  Esqueci minha senha!
                </NavLink>
              </div>
              <div>
                <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/smartimob-dev-test.appspot.com/o/polpriv.html?alt=media&token=d0816a3e-e91e-4f0e-bf68-b84d60353bb0'>
                  Política de Privacidade
                </a>
              </div>
              {
                window.screen.width < 600 && <div style={{height: 46}}></div>
              }
              {
                /**
                  <p className="form-divider">
                    <span>Or</span>
                  </p>
                  <ul className="social-login">
                    <li>
                      <Link className="google-signup" to="#">
                        <img src={require('../../../../static/img/google.png')} alt="" />
                        <span>Sign in with Google</span>
                      </Link>
                    </li>
                    <li>
                      <Link className="facebook-sign" to="#">
                        <FacebookOutlined />
                      </Link>
                    </li>
                    <li>
                      <Link className="twitter-sign" to="#">
                        <TwitterOutlined />
                      </Link>
                    </li>
                  </ul>
                */
              }
            </Form>
          </div>
        </>
      }
    </AuthWrapper>
  );
};

export default SignIn;
